import React, { createContext, useContext, useState, type ReactNode } from "react"

interface LoadContextData {
  isLoading: boolean
  isFlagLoading: boolean
  enableFlagLoad: () => void
  disableFlagLoad: () => void
  enableLoad: () => void
  disableLoad: () => void
}

const LoadContext = createContext<LoadContextData | undefined>(undefined)

interface LoadProviderProps {
  children: ReactNode
}

export const LoadProvider: React.FC<LoadProviderProps> = ({ children }) => {
  const [isLoading, setLoading] = useState(false)

  const [isFlagLoading, setFlagLoading] = useState(false)

  const enableLoad = () => setLoading(true)

  const disableLoad = () => setLoading(false)

  const enableFlagLoad = () => setFlagLoading(true)

  const disableFlagLoad = () => setFlagLoading(false)

  return (
    <LoadContext.Provider
      value={{ isLoading, isFlagLoading, enableLoad, disableLoad, disableFlagLoad, enableFlagLoad }}
    >
      {children}
    </LoadContext.Provider>
  )
}

export const useLoad = (): LoadContextData => {
  const context = useContext(LoadContext)

  if (!context) {
    throw new Error("useLoad deve ser usado dentro de um LoadProvider")
  }

  return context
}

export {}
